import React, { useContext } from 'react'
import { Button, NotificationInline, View } from 'oio-react'
import PropTypes from 'prop-types'
import statusThemes from 'config/constants/statusThemes'
import ThemeContext from 'src/libraries/contexts/Theme'

const PageStatusBar = ({ page }) => {
   const theme = useContext(ThemeContext)

   return (
      <View float="left" width="100%" backgroundColor="#fff">
         {page.archived && (
            <NotificationInline
               backgroundColor={statusThemes.archived.backgroundColor}
               iconColor={statusThemes.archived.highlightColor}
               type="info"
               title="This Page is Archived"
               message="Only admins can see this page"
               paddingHorizontal={theme.viewportPaddingLeft}
               buttonPlacement="right"
               buttons={[
                  <Button
                     key="settings"
                     color={statusThemes.archived.buttonColor}
                     linkTo={`/pages/${page.slug}/settings`}
                     name="View Settings"
                     textColor="#000"
                  />
               ]}
            />
         )}
         {!page.archived && !page.published && (
            <NotificationInline
               backgroundColor={statusThemes.unpublished.buttonColor}
               iconColor={statusThemes.unpublished.highlightColor}
               type="warning"
               title="This page is currently unpublished"
               message="While unublished, this page is only visible to Admins"
               paddingHorizontal={theme.viewportPaddingLeft}
               buttonPlacement="right"
               buttons={[
                  <Button
                     key="settings"
                     color={statusThemes.unpublished.buttonColor}
                     linkTo={`/pages/${page.slug}/settings`}
                     name="View Settings"
                     textColor="#000"
                  />
               ]}
            />
         )}
      </View>
   )
}

PageStatusBar.propTypes = {
   page: PropTypes.object.isRequired
}

export default PageStatusBar
